import { Divider, Typography, List, Box } from "@mui/material"
import AppButton from "components/StyledComponents/AppButton"
import AppTextField from "components/StyledComponents/AppTextField"
import { Formik } from "formik"
import { validationSchemaEditContest } from "helpers/validationSchema"
import React, { useEffect, useRef } from "react"
import { Fragment } from "react"
import { useTheme } from "@mui/system"
import Header from "components/Header/Header"
import { Container, Row, Col } from "react-bootstrap"
import EditPendingQuestion from "../components/EditPendingQuestion"
import AppDatePicker from "components/AppDatePicker"
import { useHistory } from "react-router-dom"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  editWeeklyChallengeAction,
  getViewChallengeQuestionsAction,
  viewWeeklyChallengeAction
} from "redux/marketing/actions"
import AppSelect from "components/StyledComponents/AppSelect"
import moment from "moment"
import StyledLabel from "components/StyledComponents/StyledLabel"
import { days } from "assets/json/DayNames"
import { COINS, initialValue } from "helpers/constant"
import SelectMenuItems from "./SelectMenuItems"
import { appActions } from "redux/app/slice/app"

function EditWeeklyChallenge() {
  const theme = useTheme()
  const history = useHistory()
  const dispatch = useDispatch()
  const statusRef = useRef("Pending")
  const [weekDaysChoices, setWeekDaysChoices] = useState([])

  const [initialValues, setInitialValues] = useState(initialValue)
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const [questionModal, setQuestionModal] = useState(false)
  const { weeklyChallengeData, challengeQuestions, challengeQuestionsCount } = useSelector(
    (store) => store?.marketing
  )

  const styles = {
    heading: {
      color: theme.palette.text.secondary
    },
    btn: {
      padding: "13px 50px"
    },
    required: {
      color: theme.palette.error.main
    }
  }

  const handleSaveAsDraft = ({ handleSubmit }) => {
    statusRef.current = "Draft"
    handleSubmit()
  }

  const handlePublish = ({ handleSubmit }) => {
    statusRef.current = "Published"
    handleSubmit()
  }

  const handleAddQuestions = ({ handleSubmit }) => {
    statusRef.current = "AddQuestions"
    handleSubmit()
  }

  const handleSelectMenuItems = () => {
    statusRef.current = "ReplaceMenuItems"
    setQuestionModal((prevQuestionModal) => !prevQuestionModal)
    // dispatch(learningDevelopmentActions.setGenerate_Question_MenuLink("dinner"))
  }

  const handleRoute = () => {
    if (statusRef.current === "AddQuestions") {
      history.replace({
        pathname: "/learning_development/dashboard/weekly-question-bank",
        state: {
          questionsCategories: new Set(challengeQuestions?.map((e) => e.category))
        }
      })
    } else {
      history.push("/learning_development/dashboard/weekly-challenge")
    }
  }

  const handleSubmit = (values) => {
    const payload = {
      flashcard_coins: values.flash_cards_coins,
      ...(statusRef.current !== "AddQuestions" ? { status: statusRef.current } : {})
    }

    dispatch(editWeeklyChallengeAction({ payload, handleRoute }))
  }

  const checkStatus = () => {
    if (weeklyChallengeData?.status?.toLowerCase() === "published") {
      return new Date(weeklyChallengeData?.start_date) > new Date()
    }
    return true
  }

  const alertUser = (e) => {
    e.preventDefault()
    e.returnValue = ""
  }

  useEffect(() => {
    const {
      name,
      created_by,
      start_date,
      end_date,
      creation_date,
      published_week_day,
      flashcard_coins
    } = {
      ...(weeklyChallengeData ?? {})
    }
    setInitialValues({
      name,
      scope: "All Restaurant",
      created_by,
      published_week_day,
      start_date: moment(start_date).utc(),
      end_date: moment(end_date).utc(),
      creation_date: moment(creation_date).utc(),
      flash_cards_coins: flashcard_coins
    })
  }, [weeklyChallengeData])

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
    document.title = "Weekly Challenge"
    dispatch(getViewChallengeQuestionsAction())
    dispatch(viewWeeklyChallengeAction())
    dispatch(appActions.setFilters({ category: [] }))

    setWeekDaysChoices(
      days.map((weekName) => ({
        label: `Every ${weekName}`,
        value: weekName.toUpperCase()
      }))
    )
  }, [])

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser)
    return () => {
      window.removeEventListener("beforeunload", alertUser)
    }
  }, [])

  return (
    <Fragment>
      {questionModal && <SelectMenuItems onClose={() => setQuestionModal(false)} />}
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        onSubmit={handleSubmit}
        validationSchema={validationSchemaEditContest}>
        {(formik) => (
          <Fragment>
            <Container fluid>
              <Row>
                <Col lg="12">
                  <Header title="Weekly Challenge" breadCrumbs={breadCrumbs}>
                    {checkStatus() ? (
                      <Typography
                        variant="body1Regular"
                        onClick={() => handleSaveAsDraft(formik)}
                        sx={{
                          color: theme.palette.secondary.main,
                          textDecoration: "underline",
                          margin: "13px 50px",
                          cursor: "pointer",
                          textUnderlineOffset: "2px"
                        }}>
                        Save Draft
                      </Typography>
                    ) : null}
                    <AppButton onClick={() => handlePublish(formik)} styles={styles.btn}>
                      Publish
                    </AppButton>
                  </Header>
                </Col>
              </Row>
            </Container>

            <Container fluid>
              <Row>
                <Col lg="4">
                  <AppTextField
                    id="name"
                    name="name"
                    fullWidth
                    label="Contest Name"
                    isRequired={true}
                    disabled={true}
                    placeholder="Enter Contest Name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                  />
                </Col>
                <Col lg="4">
                  <List sx={{ padding: 0 }}>
                    <Box>
                      <Typography variant="body1Regular" sx={styles.heading}>
                        DURATION
                      </Typography>
                      <span style={styles.required}>*</span>
                    </Box>
                    <Box sx={{ display: "flex", marginTop: "5px" }} className="datesContainer">
                      <Col lg="6" className="me-2 dateFieldContainer">
                        <AppDatePicker
                          views={["year", "month"]}
                          inputFormat="MMM yyyy"
                          key={"start_date"}
                          disabled={true}
                          value={formik.values.start_date}
                          minDate={new Date()}
                          onChange={(val) => formik.setFieldValue("start_date", val)}
                        />
                      </Col>
                    </Box>
                  </List>
                </Col>
                <Col lg="4">
                  <StyledLabel variant="body1Regular">
                    Flash card coins per question <span>*</span>
                  </StyledLabel>
                  <Col lg="12" md="10" className="mt-1">
                    <AppSelect
                      id="flash_cards_coins"
                      name="flash_cards_coins"
                      isRequired={true}
                      menuItems={COINS}
                      value={formik.values.flash_cards_coins}
                      onChange={formik.handleChange}
                      error={formik.errors.flash_cards_coins}
                      touched={formik.touched.flash_cards_coins}
                    />
                  </Col>
                </Col>
              </Row>
              <Divider className="mt-4"></Divider>
            </Container>
            <Container fluid className="mt-4 ">
              <Row>
                <Col lg="4" style={{ paddingRight: 12 }}>
                  <Box>
                    <List sx={{ padding: 0 }}>
                      <Box className="pb-1">
                        <Typography variant="body1Regular" sx={styles.heading}>
                          {"Creation Date".toUpperCase()}
                        </Typography>
                        <span style={styles.required}>*</span>
                      </Box>
                      <Box sx={{ display: "flex", marginTop: "5px" }} className="datesContainer">
                        <Col lg="12" className="dateFieldContainer">
                          <AppDatePicker
                            key="creation_date"
                            disabled
                            value={formik.values.creation_date}
                            onChange={(val) => formik.setFieldValue("creation_date", val)}
                            error={formik.errors.creation_date}
                            touched={formik.touched.creation_date}
                          />
                        </Col>
                      </Box>
                    </List>
                  </Box>
                </Col>
                <Col lg="4">
                  <AppTextField
                    id="created_by"
                    name="created_by"
                    fullWidth
                    label="Created By"
                    isDisabled={true}
                    placeholder="Enter Created By"
                    value={formik.values.created_by}
                    onChange={formik.handleChange}
                    error={formik.touched.created_by && Boolean(formik.errors.created_by)}
                    helperText={formik.touched.created_by && formik.errors.created_by}
                  />
                </Col>

                <Col lg="4">
                  <AppSelect
                    id="published_week_day"
                    name="published_week_day"
                    disabled={true}
                    menuItems={weekDaysChoices}
                    label="Publish Weekly On"
                    value={formik.values.published_week_day}
                    onChange={formik.handleChange}
                    error={
                      !checkStatus()
                        ? "Publish Weekly On is not Editable for Ongoing Contest"
                        : formik.errors.published_week_day
                    }
                    touched={!checkStatus() ? false : formik.touched.published_week_day}
                  />
                </Col>
              </Row>
              <Divider className="mt-4"></Divider>
            </Container>

            {weeklyChallengeData?.status?.toLowerCase() !== "published" && (
              <Container fluid className="mt-4">
                <Row>
                  <Col lg="12" className="d-flex justify-content-between">
                    <Typography variant="h2">Questions</Typography>
                    <Col className="d-flex justify-content-end gap-4">
                      <AppButton onClick={() => handleSelectMenuItems(formik)} styles={styles.btn}>
                        Replace Menu Item
                      </AppButton>
                      <AppButton onClick={() => handleAddQuestions(formik)} styles={styles.btn}>
                        Add Questions
                      </AppButton>
                    </Col>
                  </Col>
                </Row>
              </Container>
            )}
          </Fragment>
        )}
      </Formik>
      <Container fluid className="mt-4">
        <Row>
          <Col lg="12">
            <EditPendingQuestion
              isEdit={weeklyChallengeData.status === "Published" ? true : false}
              isCorrectAnswer={true}
              rows={challengeQuestions ?? []}
              columns={PendingColumns}
              contestData={weeklyChallengeData}
              questionCount={challengeQuestionsCount}
            />
          </Col>
        </Row>
      </Container>
    </Fragment>
  )
}

export default EditWeeklyChallenge

const PendingColumns = [
  {
    id: "S.No",
    label: "S.No",
    minWidth: 35
  },
  {
    id: "Questions",
    label: "Questions",
    minWidth: 50
  },
  {
    id: "Challenge Category",
    label: " Challenge Category",
    align: "center",
    minWidth: 90
  },
  {
    id: "Difficulty Level",
    label: "Difficulty Level",
    align: "center",
    minWidth: 120
  },
  {
    id: "Action",
    label: "Action",
    align: "center",
    minWidth: 70
  }
]
